module.exports = __webpack_public_path__ + "h5/img/index_bg.b9fd78cb.png";